(() => {
  const ROOT = '[data-designers-directory]';
  const MIN_SKELETON_MS = 320;
  const REVEAL_MS = 450;

  function wait(ms) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function waitForTransition(element, propertyName) {
    return new Promise((resolve) => {
      if (!element) {
        resolve();
        return;
      }

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        element.removeEventListener('transitionend', onEnd);
        resolve();
      };

      const onEnd = (event) => {
        if (event.target !== element) return;
        if (propertyName && event.propertyName !== propertyName) return;
        finish();
      };

      element.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, REVEAL_MS + 80);
    });
  }

  async function finishLoading(root) {
    const skeleton = root.querySelector('[data-designers-skeleton]');
    const status = root.querySelector('[data-designers-status]');
    const visible = root.querySelectorAll('.designers-directory__item');

    if (prefersReducedMotion()) {
      root.classList.remove('designers-directory--loading');
      root.classList.add('designers-directory--revealed');
      root.removeAttribute('aria-busy');
      if (skeleton) skeleton.remove();
    } else {
      root.classList.add('designers-directory--revealing');
      root.classList.remove('designers-directory--loading');
      root.classList.add('designers-directory--revealed');

      await waitForTransition(skeleton, 'opacity');

      root.classList.remove('designers-directory--revealing');
      root.removeAttribute('aria-busy');
      if (skeleton) skeleton.remove();
    }

    if (visible.length === 0 && status) {
      const emptyText = status.getAttribute('data-empty-text') || '';
      if (emptyText) {
        status.textContent = emptyText;
        status.hidden = false;
      }
    } else if (status) {
      status.hidden = true;
    }
  }

  async function init() {
    const root = document.querySelector(ROOT);
    if (!root) return;

    if (root.getAttribute('data-stock-filter') !== 'true') return;

    const started = Date.now();
    await wait(Math.max(0, MIN_SKELETON_MS - (Date.now() - started)));
    await finishLoading(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
